const fr = {
  siteName: "Akkuzey Yapı Matériaux de Construction",
  siteNameShort: "Akkuzey Yapı",

  // Textes d'interface (boutons, libellés pour lecteurs d'écran, états vides)
  ui: {
    close: "Fermer",
    back: "Retour",
    previous: "Précédent",
    next: "Suivant",
    menu: "Menu",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    logoAlt: "Akkuzey Yapı Matériaux de Construction",
    dealerLogoAlt: "Logo de la concession",
    whatsapp: "Écrivez-nous sur WhatsApp",
    productCategories: "Catégories de produits",
    subProducts: "Sous-produits",
    subCategoryNotFound: "Sous-catégorie introuvable",
    emptySubCategory: "Aucun produit dans cette sous-catégorie.",
    code: "Référence",
  },

  homeNavbar: "Accueil",
  chooseLanguage: "Choisissez la langue",
  products: "Produits",
  corporate: "Entreprise",
  affiliates: "Filiales",
  dealerships: "Nos Distributeurs",
  newsNavbar: "Actualités",
  storesFooter: "Nos Magasins",
  search_placeholder: "Rechercher un produit...",
  contactNavbar: "Contact",
  searchPlaceholder: "Rechercher un produit...",
  favorites: {
    title: "Mes Favoris",
    emptyMessage: "Aucun produit dans vos favoris.",
  },
  navbar: {
    searching: "Recherche…",
    suggestCategories: "Catégories",
    suggestProducts: "Produits",
    seeAllResults: "Voir tous les résultats ({{count}})",
    searchPlaceholder: "Saisissez le produit recherché…",
    search: "CHERCHER",
    callUs: "Appelez-nous",
    myCart: "Mon panier",
    allCategories: "Toutes les catégories",
    cats: {
      insaat: "Construction",
      hirdavat: "Quincaillerie",
      elAletleri: "Outillage",
      boya: "Peinture",
      yapiKimyasallari: "Chimie du bâtiment",
      tesisat: "Plomberie",
      banyo: "Salle de bain",
      elektrik: "Électricité",
      makinalar: "Machines",
      kesme: "Coupe & Perçage",
    },
  },
  topBanner: {
    message:
      "akkuzey@hotmail.com | +90 537 798 11 29 | Istanbul GMT+3 | Lun–Sam (08:00–20:00) | Dim (11:00–18:30)",
  },
  subMenus: {
    corporate: {
      about: "À propos",
      contact: "Contact",
      qualityPolicy: "Politique Qualité",
      complaints: "Formulaire Réclamations & Suggestions",
      faq: "FAQ",
    },
    affiliates: {
      construction: "Akkuzey Construction",
      automotive: "Akkuzey Automobile",
    },
  },
  home: {
    featuredBrandsEyebrow: "Marques Phares",
    featuredBrandsTitle: "Vos marques de confiance, en un clic",
    brandProductCount: "{{count}} produits",
    newArrivalsEyebrow: "Nouveautés",
    newArrivalsTitle: "Ajoutés récemment au catalogue",
    seeCatalog: "Voir tout le catalogue",
    viewDetails: "Voir les détails",
    hero: {
      eyebrow: "Matériaux de construction depuis 1972",
      title:
        "De la salle de bains à la quincaillerie, une fourniture complète à une seule adresse.",
      subtitle:
        "Depuis plus d'un demi-siècle, Akkuzey Yapı fournit des produits de construction, de plomberie, de quincaillerie et de salle de bains–cuisine, en gros et au détail, depuis Zeytinburnu, Istanbul.",
      ctaPrimary: "Voir les produits",
      ctaSecondary: "Nous contacter",
      stats: {
        foundedValue: "1972",
        foundedLabel: "Fondation",
        dealersValue: "40+",
        dealersLabel: "Concessions agréées",
        storesValue: "2",
        storesLabel: "Magasins · Istanbul",
      },
    },
    brands: {
      title: "Nos concessions agréées",
      link: "Voir tout",
    },
    wholesale: {
      eyebrow: "Vente en gros",
      title: "Briques et ciment en gros, livrés sur votre chantier.",
      subtitle:
        "Nous fournissons briques, ciment et matériaux de construction essentiels à prix de gros, livrés directement sur votre chantier. Demandez un devis selon vos quantités et votre calendrier de livraison.",
      items: {
        brick: "Brique",
        brickNote: "Creuse, pleine et béton cellulaire",
        cement: "Ciment",
        cementNote: "En sacs et en vrac",
        delivery: "Livraison sur chantier",
        deliveryNote: "Expédition selon le planning du projet",
      },
      ctaPrimary: "Demander un Devis en Gros",
      ctaSecondary: "Appelez-nous",
      phone: "+90 537 798 11 29",
    },
    cta: {
      title: "Choisissons ensemble le bon matériau pour votre projet.",
      subtitle:
        "Contactez-nous pour toute information sur les produits, les stocks et les prix, ou visitez nos magasins.",
      primary: "Nous contacter",
      secondary: "Nos magasins",
    },
    campaigns: {
      showerSets: {
        title: "Nouvelle Saison des Ensembles de Douche",
        brand: "VitrA · ECA · Creavit",
      },
      paintRollers: {
        title: "Rouleaux et Pinceaux",
        brand: "Dekor",
      },
      sealants: {
        title: "Silicones, Mastics et Mousses de Montage",
        brand: "Selsil",
      },
      basinMixers: {
        title: "Un Large Choix de Mitigeurs Lavabo",
        brand: "ECA · VitrA · Creavit",
      },
      interiorPaints: {
        title: "Peintures Intérieures",
        brand: "Filli Boya · Polisan · Marshall",
      },
      bathroomKitchen: {
        title: "Faites la différence dans votre salle de bain et cuisine",
        brand: "Produits Premium",
      },
      bathroomAccessories: {
        title: "Accessoires de salle de bain et plus",
        brand: "Prix Réduits",
      },
      modernAccessories: {
        title: "Accessoires Modernes",
        brand: "Prix Spéciaux",
      },
      bathroomCabinets: {
        title: "Des centaines d’options d’armoires de salle de bain",
        brand: "Marques de renommée mondiale",
      },
      selsil: {
        title: "Quel produit Selsil ?",
        brand: "Trouvez ce dont vous avez besoin",
      },
      sprayPaint: {
        title: "Des centaines de couleurs de peinture en spray !",
        brand: "Qualité Maximale",
      },
    },
  },

  bathroomAccessories: {
    title: "Accessoires de salle de bain",
    products: {
      soapDish: "Porte-savon",
      towelHolder: "Porte-serviette",
      emergencySupportShelf: "Étagère d’angle avec support",
      cornerSoapDish: "Porte-savon d’angle à 3 niveaux – Blanc",
    },
  },

  bathroomCabinets: {
    title: "Armoires de salle de bain",
    products: {
      firdevsSet: "Ensemble Armoire Firdevs",
      klasikSet: "Ensemble Armoire Classique",
      asyaSet: "Ensemble Armoire Asya",
      quadrumAsma: "Armoire Murale Quadrum",
    },
  },

  bathroomKitchen: {
    title: "Robinetterie Salle de Bain & Cuisine",
    products: {
      begonyaShowerSet: "Ensemble Douche Begonya – Chrome",
      spiralKitchenFaucet: "Robinet de cuisine flexible",
      ritaSinkFaucet: "Robinet Lavabo Rita",
      ritaBathFaucet: "Robinet Bain Rita",
      laraBlackSinkFaucet: "Robinet Lavabo Lara Black",
      laraBlackBathFaucet: "Robinet Bain Lara Black",
      alyaSinkFaucet: "Robinet Lavabo Alya",
      alyaBathFaucet: "Robinet Bain Alya",
    },
    barcode: "Code-barres",
    code: "Référence",
    brand: "Marque",
    color: "Couleur",
    colors: {
      chrome: "Chromé",
      black: "Noir",
    },
  },

  stores: {
    title: "Nos Magasins",
    subtitle: "Visitez nos magasins pour découvrir la qualité de nos services.",
    map: "Carte",
    istanbul: {
      city: "Istanbul",
      name: "Magasin Istanbul",
      address: "Çırpıcı, 75/2. Sk. No:109, Zeytinburnu/Istanbul",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "Lun–Sam : 08:00–20:00, Dim : 11:00–18:30",
    },
    ankara: {
      city: "Istanbul",
      name: "Succursale Istanbul",
      address: "Beştelsiz, 1. Yol Sk. No:7, Zeytinburnu/Istanbul",
      phone: "+90 537 798 11 29",
      email: "akkuzey@hotmail.com",
      hours: "Lun–Sam : 08:00–20:00, Dim : 11:00–18:30",
    },
  },

  modernAccessories: {
    title: "Accessoires Modernes",

    products: {
      suspendedCeilingPanel: "Panneau de plafond suspendu acoustique",
      modernDoorHandleBlack: "Poignée de porte moderne noir mat",
      modernDoorHandleChrome: "Poignée de porte moderne chrome satiné",
      sensorSoapDispenser: "Distributeur de savon automatique à capteur",
    },
  },

  selsil: {
    title: "Catalogue Produits Selsil",
    barcode: "Code-barres",
    code: "Référence",
    brand: "Marque",
    color: "Couleur",
    colors: {
      white: "Blanc",
      black: "Noir",
      red: "Rouge",
      green: "Vert",
      blue: "Bleu",
      gray: "Gris",
      lightGray: "Gris Clair",
      transparent: "Transparent",
    },
    products: {
      siliconeTransparent: { name: "Silicone Transparent 280 g" },
      siliconeWhite: { name: "Silicone Blanc 280 g" },
      siliconeBlack: { name: "Silicone Noir 280 g" },
      masticWhite: { name: "Mastic Blanc 450 g" },
      foam600gr: { name: "Mousse 600 g" },
      rtvHeatSilicone: { name: "Silicone Haute Température Rouge" },
      miraculouspackage: {
        name: "Selsil Pak Nettoyant Mousse Miracle 500 ml",
      },
      SelsilCleaning: {
        name: "Selsil Pak Nettoyant Miracle Multi-Usage 500 g",
      },
      StainRemover: {
        name: "Selsil Pak Spray Détachant 150 ml",
      },
      puMasticBlack: { name: "Mastic PU Noir 280 ml" },
      puMasticGray: { name: "Mastic PU Gris 280 ml" },
      puMasticWhite: { name: "Mastic PU Blanc 280 ml" },
      multiPurposeSpray: { name: "Spray Multi-Usage 400 ml" },
      selsilSprayB: { name: "Selsil Spray B 400 ml" },
    },
  },

  sprayPaint: {
    title: "Catalogue Peintures en Spray",
    productName: "Peinture en aérosol Akçalı 400 ml {{color}}",
    code: "Référence",
    unit: "Unité",
    category: "Catégorie",
    color: "Couleur",
    categories: {
      paint: "Peinture",
    },
    colors: {
      white: "Blanc",
      black: "Noir",
      red: "Rouge",
      green: "Vert",
      blue: "Bleu",
      gray: "Gris",
      lightGray: "Gris Clair",
      lightBrown: "Marron Clair",
      orange: "Orange",
      lightGreen: "Vert Clair",
      taxiYellow: "Jaune Taxi",
      bordeaux: "Bordeaux",
      purple: "Violet",
      lightBlue: "Bleu Clair",
      beadBlue: "Bleu Perlé",
      turquoise: "Turquoise",
      navyBlue: "Bleu Marine",
      glossWhite: "Blanc Brillant",
      beige: "Beige",
      chromeYellow: "Jaune Chrome",
      brown: "Marron",
      glossBlack: "Noir Brillant",
      matteWhite: "Blanc Mat",
      matteBlack: "Noir Mat",
      trafficWhite: "Blanc Trafic",
      pearlWhite: "Blanc Nacré",
      mossGreen: "Vert Mousse",
      anthracite: "Anthracite",
      gloss: "Brillant",
      matte: "Mat",
      saten: "Satiné",
      darkGray: "Gris Foncé",
      smoke: "Fumé",
      bronze: "Bronze",
      lightAluminium: "Aluminium Clair",
      mediumGray: "Gris Moyen",
      bumperBlack: "Noir Pare-chocs",
      bumperWhite: "Blanc Pare-chocs",
      enamelStoveBrown: "Peinture Émail Poêle Marron",
      metallicBlack: "Noir Métallisé",
      metallicYellow: "Jaune Métallisé",
      metallicBlue: "Bleu Métallisé",
      grayWhite: "Blanc Grisé",
      oxideYellow: "Jaune Oxyde",
      fuchsia: "Fuchsia",
      machineRed: "Rouge Machine",
      scarlet: "Écarlate",
      fluorescentYellow: "Jaune Fluorescent",
      fluorescentLilac: "Lilas Fluorescent",
      fluorescentRed: "Rouge Fluorescent",
      fluorescentDarkRed: "Rouge Foncé Fluorescent",
      fluorescentOrange: "Orange Fluorescent",
      plasticPrimer: "Apprêt pour Surfaces Plastiques",
    },
    products: {
      akcaliSpray400ml: "Peinture Spray Akçalı 400 ml",
      akcaliVarnish400ml: "Vernis Akçalı 400 ml",
      akcaliBumperPaint400ml: "Peinture Pare-Chocs Voiture Akçalı 400 ml",
      akcaliWheelPaint400ml: "Peinture Jantes Automobile Akçalı 400 ml",
    },
  },

  dealershipsPage: {
    title: "Nos Distributeurs",
    subtitle:
      "Grâce à notre large réseau, vous pouvez accéder facilement à nos produits.",
    brands: {
      abb: "ABB",
      armaş: "Armaş",
      baylan: "Baylan",
      ecesan: "Ecesan",
      fluke: "Fluke",
      isonem: "Isonem",
      kalekim: "Kalekim",
      karbon: "Karbon",
      makel: "Makel",
      metoba: "Metoba",
      optimum: "Optimum",
      pelsan: "Pelsan",
      pimtaş: "Pimtaş",
      polisan: "Polisan",
      selsil: "Selsil",
      sista: "Sista",
      viko: "Viko",
      vitra: "Vitra",
      yaparlar: "Yaparlar",
      yds: "YDS",
      alarko: "Alarko",
      askaynak: "Askaynak",
      ayvaz: "Ayvaz",
      beybi: "Beybi",
      bmex: "BMEX",
      bonuspan: "Bonuspan",
      bosh: "Bosch",
      çayırva: "Çayırva",
      dekor: "Dekor",
      dewalt: "Dewalt",
      duyar: "Duyar",
      ebitt: "Ebitt",
      eca: "ECA",
      feica: "Feica",
      fırat: "Fırat",
      honey: "Honeywell",
      kale: "Kale",
      knipex: "Knipex",
      köse: "Köse",
      metresan: "Metresan",
      marshall: "Marshall",
      stanley: "Stanley",
      tekno: "Tekno",
      turkuaz: "Turkuaz",
      pakkens: "Pakkens",
      rothenberg: "Rothenberg",
      sonneflex: "Sonneflex",
      sumak: "Sumak",
      yalteks: "Yalteks",
    },
  },
  product: {
    zoom: "Agrandir",
    close: "Fermer",
    share: "Partager",
    linkCopied: "Lien copié",
    notFound: "Produit introuvable.",
    backToCatalog: "Retour au catalogue",
    options: "Options",
    askWhatsapp: "Demander sur WhatsApp",
    whatsappText: "Bonjour, je souhaite connaître le prix et la disponibilité de {{ad}}{{secenek}}.",
    call: "Appelez-nous",
    description: "Description du Produit",
    autoDescription: "{{ad}} est un produit {{marka}} de la gamme {{kategori}}.",
    optionsSentence: "Disponible en {{sayi}} options : {{liste}}.",
    priceInfo: "Contactez-nous sur WhatsApp ou par téléphone pour le prix et le stock actuels ; prix spéciaux pour les commandes en gros.",
    metaDescription: "{{ad}} — {{marka}} {{kategori}}. Prix et disponibilité chez Akkuzey Matériaux de Construction.",
    related: "Produits Similaires",
    viewAll: "Tout voir",
    trust: {
      wholesaleTitle: "Gros et Détail",
      wholesale: "Prix spéciaux pour chantiers et artisans",
      sinceTitle: "Depuis 1972",
      since: "Fourniture de matériaux à Zeytinburnu",
      quoteTitle: "Devis Rapide",
      quote: "Envoyez votre liste en un message WhatsApp",
    },
  },
  recent: {
    eyebrow: "Reprenez où vous en étiez",
    title: "Récemment Consultés",
    clear: "Vider la liste",
  },
  calc: {
    materialList: "Liste des matériaux",
    print: "Imprimer / PDF",
    copyLink: "Copier le lien",
    suggested: "Produits conseillés pour ce chantier",
    stepArea: "Surface et dimensions",
    stepProduct: "Produit et application",
    approx: "env.",
    tabsHint: {
      boya: "Litres et pots",
      duvar: "Pièces et mortier",
      seramik: "Cartons, colle, joint",
      beton: "m³ et ciment",
      alci: "Nombre de sacs",
      alcipan: "Plaques, rails, vis",
    },
    tile: {
      area: "Surface à carreler",
      straight: "Pose droite (10 % de perte)",
      diagonal: "Pose diagonale (15 % de perte)",
      stepTile: "Format du carreau",
      tileWidth: "Largeur",
      tileHeight: "Longueur",
      thickness: "Épaisseur",
      boxM2: "Surface par carton",
      boxHint: "Indiquée sur le carton (ex. 1,44 m² pour 60×60)",
      stepAdhesive: "Colle et joint",
      adhesive: "Consommation de colle",
      adhesiveHint: "5–7 kg/m² pour grands formats, 3–4 kg/m² pour petits",
      joint: "Largeur du joint",
      result: "Cartons nécessaires",
      boxes: "cartons",
      tiles: "Carreaux",
      adhesiveItem: "Colle à carrelage",
      groutItem: "Joint",
      browse: "Voir les colles",
      whatsapp: "Bonjour, j’ai calculé des carreaux {{olcu}} cm pour {{alan}} m² : {{adet}} pcs ({{kutu}} cartons), {{torba}} sacs de colle et {{derz}} kg de joint. Puis-je avoir un prix ?",
    },
    concrete: {
      thickness: "Épaisseur",
      type: "Application",
      type_sap: "Chape",
      type_grobeton: "Béton de propreté (C16)",
      type_c25: "Béton C25",
      type_c30: "Béton C30",
      dosage: "Dosage en ciment",
      dosageHint: "Ciment par m³ ; à adapter au projet",
      result: "Ciment nécessaire",
      cementBags: "sacs",
      cement: "Ciment",
      sand: "Sable",
      aggregate: "Sable et gravier",
      readyMix: "En béton prêt à l’emploi",
      readyMixNote: "volume à commander",
      volume: "Volume",
      browse: "Voir les ciments",
      whatsapp: "Bonjour, j’ai calculé {{hacim}} m³ de {{tip}} : {{torba}} sacs ({{kg}} kg) de ciment. Puis-je avoir un prix ?",
    },
    drywall: {
      stepSystem: "Système de cloison",
      faces: "Faces à plaquer",
      oneFace: "Une face",
      twoFaces: "Deux faces",
      layers: "Couches de plaques",
      single: "Simple",
      double: "Double",
      spacing: "Entraxe des montants",
      result: "Plaques nécessaires",
      boards: "plaques",
      boardItem: "Plaque de plâtre",
      cProfile: "Montant C",
      studs: "montants",
      uProfile: "Rail U (sol-plafond)",
      screws: "Vis à plaque",
      tape: "Bande à joint",
      jointFiller: "Enduit à joint",
      browse: "Voir les systèmes plaque de plâtre",
      whatsapp: "Bonjour, j’ai calculé une cloison de {{alan}} m² : {{levha}} plaques, {{c}} montants C, {{u}} rails U, {{vida}} vis. Puis-je avoir un prix ?",
    },
    eyebrow: "Calculateur de Matériaux",
    title: "De combien de matériau avez-vous besoin ?",
    subtitle: "Saisissez vos mesures et obtenez la liste détaillée des matériaux pour peinture, briques, carrelage, béton et chape, plâtre et cloisons. Imprimez-la ou envoyez-la par WhatsApp pour un devis.",
    tabs: {
      seramik: "Carrelage",
      beton: "Béton et Chape",
      alcipan: "Cloison Plâtre",
      boya: "Peinture",
      duvar: "Briques et Béton Cellulaire",
      alci: "Plâtre",
    },
    askQuote: "Obtenir un prix pour cette quantité",
    disclaimer: "Les résultats sont des estimations et peuvent varier selon la surface et le produit.",
    width: "Largeur",
    length: "Longueur",
    height: "Hauteur",
    openings: "Surface portes / fenêtres",
    openingsHint: "Surface à déduire",
    netArea: "Surface nette",
    liter: "litres",
    pieces: "pcs",
    waste: "Marge de perte",
    wasteHint: "Pour la casse et les coupes",
    viewProduct: "Voir le produit",
    paint: {
      item: "Peinture",
      primer: "Sous-couche",
      primerNote: "Une couche, ~12 m²/L",
      addPrimer: "Inclure la sous-couche",
      mode_oda: "Par dimensions de pièce",
      mode_alan: "Par surface totale",
      includeCeiling: "Peindre aussi le plafond",
      area: "Surface à peindre",
      coats: "Couches",
      coatUnit: "couches",
      coverage: "Rendement",
      coverageHint: "Indiqué sur l’étiquette ; en général 8–12 m²/L",
      result: "Peinture nécessaire",
      packages: "Pots conseillés",
      browse: "Voir les peintures",
      whatsapp: "Bonjour, j’ai calculé {{kat}} couches pour {{alan}} m² : environ {{litre}} litres ({{paket}}). Puis-je avoir un prix ?",
    },
    wall: {
      mortar: "Mortier de maçonnerie",
      thinMortar: "Mortier-colle béton cellulaire",
      length: "Longueur du mur",
      block: "Brique / bloc",
      custom: "Saisir la taille",
      blockLength: "Longueur du bloc",
      blockHeight: "Hauteur du bloc",
      joint: "Épaisseur du joint",
      jointHint: "~10 mm pour la brique, ~3 mm pour le béton cellulaire",
      result: "Nombre nécessaire",
      perM2: "Par m²",
      browse: "Voir briques et blocs",
      whatsapp: "Bonjour, j’ai calculé {{blok}} pour un mur de {{alan}} m² : environ {{adet}} pièces. Puis-je avoir un prix ?",
    },
    plaster: {
      type: "Type de produit",
      type_makine: "Plâtre machine",
      type_perlitli: "Plâtre perlé (manuel)",
      type_saten: "Plâtre de finition",
      area: "Surface",
      thickness: "Épaisseur",
      consumption: "Consommation",
      consumptionHint: "Approximative ; à ajuster selon la fiche technique",
      bag: "Sac",
      result: "Sacs nécessaires",
      bags: "sacs",
      total: "Total",
      bagSize: "Poids du sac",
      browse: "Voir les plâtres",
      whatsapp: "Bonjour, j’ai calculé {{tip}} ({{kalinlik}} mm) pour {{alan}} m² : environ {{torba}} sacs ({{kg}} kg). Puis-je avoir un prix ?",
    },
    navbarItem: "Calculateur",
    teaserEyebrow: "Outil gratuit",
    teaserTitle: "Calculez la quantité de matériaux nécessaire",
    teaserText: "Calculez peinture, briques et plâtre selon vos mesures et envoyez le résultat par WhatsApp pour un devis.",
    teaserCta: "Commencer le calcul",
  },
  shop: {
    searchPlaceholder: "Rechercher un produit…",
    searchAllPlaceholder: "Rechercher dans tous les produits…",
    searchResultsFor: "Résultats pour « {{q}} »",
    searchNoResult: "Aucun produit ne correspond à votre recherche.",
    brandProducts: "Produits {{marka}}",
    categoryProducts: "Produits de cette catégorie",
    cart: "Panier",
    cartTitle: "Ma Liste de Devis",
    cartEmpty: "Votre liste est vide.",
    cartEmptyHint: "Utilisez « Ajouter au panier » pour constituer votre liste de devis.",
    addToCart: "Ajouter au panier",
    added: "Ajouté",
    remove: "Retirer",
    clear: "Vider la liste",
    selectSize: "Choisir le format",
    subCategories: "Sous-catégories",
    brands: "Marques",
    allBrands: "Toutes",
    clearFilters: "Effacer les filtres",
    productCount: "{{count}} produits",
    tileZoom: "Voir l’image",
    tileExplore: "Découvrir",
    noResult: "Aucun produit ne correspond à ces filtres.",
    whatsappSend: "Demander un devis via WhatsApp",
    whatsappIntro:
      "Bonjour, je souhaite obtenir des informations et un tarif pour les produits suivants :",
    whatsappOutro: "Merci.",
    quantity: "Qté",
    productFeatures: {
      "mukemmel-inceltici": "Excellent diluant",
      "su-bazli": "À base d'eau",
      "makinede-renklendirilebilen-beyaz": "Blanc teintable en machine",
      "yuksek-kaplama-alani": "Grand pouvoir couvrant",
      "yuzey-hatalarini-gizler": "Masque les défauts de surface",
      "uzun-omurlu": "Longue durée",
      "dusuk-koku": "Faible odeur",
      "rahat-uygulama": "Application facile",
      "lekeleri-gizler": "Masque les taches",
      "yuksek-renk-dayanimi": "Haute tenue de la couleur",
      "yuksek-ortuculuk": "Haute opacité",
      "uzun-sureli-beyazlik": "Blancheur durable",
      "hizli-kuruyan": "Séchage rapide",
      "tutunmayi-kuvvetlendirir-ve-son-katin-da":
        "Renforce l'adhérence et la tenue de la finition",
      "kolay-temizlenir": "Facile à nettoyer",
      "leke-dayanimli": "Résistant aux taches",
      silinebilir: "Lessivable",
      "pas-onleyici": "Antirouille",
      "coklu-yuzeyler-icin": "Pour surfaces multiples",
      "hazirlar-korur-ve-guclendirir": "Prépare, protège et renforce",
      "basit-ve-kolay-yuzey-hazirligi": "Préparation de surface simple et rapide",
      "astar-gerektirmez": "Sans primaire",
      "guclendirilmis-sizdirmazlik": "Étanchéité renforcée",
      "toz-tutmaz": "Anti-poussière",
      "uzun-sureli-dayanim": "Durabilité longue durée",
      "kuf-olusumuna-direncli": "Résistant aux moisissures",
      "ultra-yapisma": "Ultra adhérence",
      "sicratma-ve-damlatma-yapmaz": "Sans éclaboussures ni coulures",
      "uv-dayanikli": "Résistant aux UV",
      "her-turlu-hava-sartlarina-dayanikli": "Résistant à toutes les intempéries",
      "scuff-mark-resistant-teknolojisi": "Technologie Scuff Mark Resistant",
      "guclu-cizilme-direnci": "Forte résistance aux rayures",
      "15-kat-daha-fazla-silinebilir": "15 fois plus lessivable",
      "ultra-yikanabilir": "Ultra lavable",
      "ultra-kapatici": "Ultra couvrant",
      "5-kat-daha-fazla-silinebilir": "5 fois plus lessivable",
      "kokusuz-ve-cevre-dostu": "Sans odeur et écologique",
      "smartsil-teknolojisi": "Technologie SmartSil",
      yikanabilir: "Lavable",
      "sicratmaz-kolay-uygulanir": "Sans éclaboussures, facile à appliquer",
    },
  },
  notFound: {
    title: "La page que vous recherchez est introuvable.",
    subtitle:
      "L'adresse a peut-être changé ou été mal saisie. Vous pouvez continuer via les liens ci-dessous.",
    home: "Retour à l'Accueil",
  },

  news: {
    title: "Actualités",
    subtitle:
      "Consultez les dernières nouvelles du secteur et les publications concernant Akkuzey.",
    readMore: "Lire la suite",
    showLess: "Afficher moins",
    articles: {
      newTools: {
        title: "Nouveaux outils manuels de dernière génération",
        date: "20 Septembre 2025",
        description:
          "Des outils ergonomiques et durables arrivent sur le marché, prêts à révolutionner le secteur.",
      },
      energyEfficiency: {
        title: "Efficacité énergétique dans les outils électriques",
        date: "15 Septembre 2025",
        description:
          "De nouveaux outils consomment 30% d'énergie en moins tout en offrant une performance maximale.",
      },
      exportRecord: {
        title: "La Turquie bat un record d’exportation",
        date: "10 Septembre 2025",
        description:
          "Le secteur connaît une forte croissance en Europe et au Moyen-Orient.",
      },
      measurementDevices: {
        title: "Nouvelles tendances des appareils de mesure intelligents",
        date: "05 Septembre 2025",
        description:
          "Les outils laser intelligents offrent une grande précision et rapidité.",
      },
    },
  },

  qualityPolicy: {
    title: "Politique Qualité",
    policies: {
      customerSatisfaction: {
        title: "Satisfaction Client",
        description:
          "La qualité de service et la compréhension des besoins clients sont notre priorité.",
      },
      reliability: {
        title: "Fiabilité",
        description:
          "Nous travaillons avec des fabricants leaders et respectons nos engagements.",
      },
      ethicalValues: {
        title: "Valeurs Éthiques",
        description:
          "Honnêteté, transparence et travail d’équipe font partie de nos valeurs.",
      },
      customerFocus: {
        title: "Orientation Client",
        description:
          "Nous analysons correctement les besoins et offrons des produits de qualité à prix compétitifs.",
      },
      quickSolution: {
        title: "Solutions Rapides",
        description:
          "Notre équipe expérimentée apporte des solutions efficaces et rapides.",
      },
    },
  },

  viewStores: "Voir Nos Magasins",

  footer: {
    description: "Akkuzey s’engage à offrir qualité, fiabilité et durabilité.",
    contactButton: "Contact",
    corporate: {
      title: "Entreprise",
      about: "À propos",
      contact: "Contact",
      complaints: "Réclamations & Suggestions",
      faq: "FAQ",
    },
    quickMenu: { title: "Menu Rapide" },
    map: { title: "Nous Trouver" },
    copyright: "© {{year}} Akkuzey Matériaux de Construction. Tous droits réservés.",
    contactInfo: {
      title: "Coordonnées",
      address: "Çırpıcı Mah. 75/2 Sk. No:109/1, Zeytinburnu / Istanbul",
      directions: "Itinéraire",
      weekdays: "Lun – Sam : 08:00 – 20:00",
      sunday: "Dimanche : 11:00 – 18:30",
    },
    brandsStrip: {
      title: "Marques phares",
      subtitle: "Cliquez sur une marque pour voir tous ses produits.",
    },
    social: {
      whatsapp: "Écrivez-nous sur WhatsApp",
      instagram: "Suivez-nous sur Instagram",
    },
  },

  faq: {
    title: "FAQ",
    subtitle: "Trouvez les réponses aux questions les plus fréquentes",
    contactPrompt: "Vous n’avez pas trouvé votre réponse ?",
    contactButton: "Accéder au formulaire",
    questions: {
      qualityStandards: {
        question: "À quelles normes de qualité vos produits répondent-ils ?",
        answer:
          "Tous nos produits respectent les normes TSE et internationales.",
      },
      technicalSupport: {
        question: "Puis-je obtenir une assistance technique ?",
        answer: "Oui, notre équipe fournit une assistance complète.",
      },
      bulkSupply: {
        question: "Fournissez-vous des matériaux en gros pour chantiers ?",
        answer: "Oui, nous proposons des tarifs spéciaux pour les projets.",
      },
      productCatalogs: {
        question: "Comment accéder à vos catalogues ?",
        answer:
          "Vous pouvez les télécharger sur notre site ou les demander par e-mail.",
      },
      customProduction: {
        question: "Proposez-vous une production personnalisée ?",
        answer: "Oui, pour certains groupes de produits.",
      },
      training: {
        question: "Fournissez-vous des formations d’application ?",
        answer:
          "Oui, des sessions professionnelles sont organisées régulièrement.",
      },
    },
  },

  complaintForm: {
    title: "Formulaire Réclamations & Suggestions",
    subtitle: "Vos retours sont précieux",
    fields: {
      name: "Nom complet",
      phone: "Numéro de téléphone",
      orderNumber: "Numéro de commande",
      type: "Type",
      message: "Message",
    },
    placeholders: {
      name: "Entrez votre nom complet",
      phone: "5__ ___ __ __",
      orderNumber: "Entrez le numéro de commande",
      message: "Décrivez en détail...",
    },
    types: {
      complaint: "Réclamation",
      suggestion: "Suggestion",
      request: "Demande",
    },
    submit: "Envoyer",
    submitting: "Envoi...",
    footerNote:
      "* Les champs obligatoires doivent être remplis. Nous vous répondrons rapidement.",
  },

  about: {
    title: "À propos de nous",
    mainParagraph:
      "Fondée en 1972 à Istanbul, Akkuzey a débuté dans la vente en gros d’outillage et a grandi grâce à son engagement envers la qualité et la satisfaction client.",
    corporateDevelopment: {
      title: "Développement de l’Entreprise",
      description:
        "Grâce à la R&D et à l’élargissement de notre gamme, nous continuons à croître sous la direction d’Adem Akkuzey.",
    },
    futureVision: {
      title: "Notre Vision",
      description:
        "Devenir une marque nationale de référence grâce à une stratégie durable et orientée client.",
    },
    quote: {
      text: `"Avec l’héritage de nos fondateurs, nous travaillons avec détermination pour bâtir une histoire de réussite durable."`,
      author: "Adem Akkuzey — Président",
    },
  },

  contact: {
    title: "Contact",
    subtitle: "Notre équipe professionnelle est prête à vous accompagner.",
    offices: {
      headOffice: {
        title: "Siège Social",
        address:
          "Çırpıcı Mah. 75/2 Sk. No:109/1\nZeytinburnu / Istanbul, Turquie",
        phone1Label: "Tél 1",
        phone1: "0 (212) 415 45 11",
        phone2Label: "Tél 2",
        phone2: "0 (537) 798 11 29",
        emailLabel: "E-mail",
        email: "akkuzey@hotmail.com",
      },
      branch: {
        title: "Agence",
        address:
          "Beştelsiz Mah. 5. Yol Sk. No:7/A\nZeytinburnu / Istanbul, Turquie",
        phoneLabel: "Téléphone",
        phone: "0 (212) 665 28 72",
      },
    },
    quickContact: {
      title: "Contact Rapide",
      phone: {
        label: "Support Client",
        number: "+90 212 415 45 11",
      },
      whatsapp: {
        label: "Via WhatsApp",
        action: "Envoyer un message",
      },
      email: {
        label: "Envoyer un email",
        address: "akkuzey@hotmail.com",
      },
    },
  },
};

export default fr;
